import * as angular from "angular";

"use strict";

angular.module("scanStationService")
    .factory("scanStation", ScanStationService)
    .config(ScanStationServiceConfig);

ScanStationService.$inject = ["$http", "Configuration", "DateService"];

function ScanStationService($http, Configuration, DateService) {

    let Factory = this;
    let scanStationObjectDetails = {};

    /**
     * Constructor method.
     */
    Factory.$onInit = () => {
        try {
            // console.log('Start: Scan Station Services');
            Factory.apiUrl = Configuration.getApiUrl();
            Factory.evervaultEnabledApiUrl = Configuration.getEvervaultInboundRelayUrl();
            Factory.evervaultFieldSlugs = Configuration.getEvervaultFieldSlugs();
            Factory.scanStationList = [];
            Factory.scanStationUsers = undefined;
            Factory.scanStationData = undefined;
            Factory.scanStationDataProcessedID = undefined;

        } catch (exception) {
            console.log(exception);
        }
    };

    /**
     * A purpose built delay function because events do not return a promise so we cannot use async/await
     * TODO get Rafs thoughts on this
     **/
    Factory.delay = ms => new Promise(res => setTimeout(res, ms));

    /**
     * This will save a scan station data.
     */
    Factory.saveScanStation = (scanStation) => {
        return Factory.scanStationList.push(scanStation);
    };

    /**
     * This will load a saved scan station.
     */
    Factory.getSavedScanStation = () => {

        let scanStation;

        if (Factory.scanStationList.length - 1 <= 0) {
            scanStation = Factory.scanStationList[0];
        } else {
            scanStation = Factory.scanStationList[Factory.scanStationList.length - 1];
        }

        return scanStation;
    };

    /**
     * This will return a scan station.
     */
    Factory.returnScanStation = () => {

        let scanStation;
        let closePopUp;
        if (Factory.scanStationList.length - 1 <= 0) {
            scanStation = Factory.scanStationList[0];
            closePopUp = true;
        } else {
            scanStation = Factory.scanStationList[Factory.scanStationList.length - 1];

            if (Factory.scanStationList.length <= 1) {
                closePopUp = Factory.scanStationList.length <= 1;
                Factory.scanStationList = [];
            }
        }
        Factory.scanStationList.pop();
        let result = [scanStation, closePopUp];

        return result;
    };

    /**
     * This will be getting the scanStation Rules.
     */
    Factory.getScanStationRules = (scanStationID) => {

        let apiBase = Factory.apiUrl + "get-scan-station-rules";
        let config = {
            params: {
                scanStationID: scanStationID,
            },
        };
        return $http.get(apiBase, config);
    };

    /**
     * This will get Rule Data.
     */
    Factory.getRuleData = () => {
        let apiBase = Factory.apiUrl + "get-rule-data";
        let config = {};
        return $http.get(apiBase, config);
    };

    /**
     * This will be updating a scan station.
     */
    Factory.updateScanningStation = (jobID, scanStationFields, fieldsToDelete, scanStationID, fieldRulesToAdd,
                                     fieldRulesToDelete, selectedSOPFiles, stationUnits, editNewRuleCase = false,
    ) => {

        let apiBase = Factory.apiUrl + "update-scan-station";
        let data = {
            "jobID": jobID,
            "scanStationFields": scanStationFields,
            "fieldsToDelete": fieldsToDelete,
            "scanStationID": scanStationID,
            "fieldRulesToAdd": fieldRulesToAdd,
            "fieldRulesToDelete": fieldRulesToDelete,
            "selectedSOPFiles": selectedSOPFiles,
            "stationUnits": stationUnits,
            "editNewRuleCase": editNewRuleCase,
        };

        return $http.post(apiBase, data);
    };

    /**
     * This will update a scan Station Object Order.
     */
    Factory.updateScanStationObjectOrder = (beforeField, changeField) => {

        let apiBase = Factory.apiUrl + "update-scan-station-object-order";

        let data = {
            "beforeField": beforeField,
            "changeField": changeField,
        };

        return $http.post(apiBase, data);
    };

    /**
     * This will be getting the scan station field order
     * @param scanStationId
     * @param limit
     */
    Factory.getScanStationFieldsOrder = async (scanStationId, limit) => {

        let scanStationFieldsOrder = [];
        let apiBase = Factory.apiUrl + "get-scan-station-fields-order";
        let config = {
            params: {
                id: scanStationId,
                limit: limit,
            },
        };

        let scanStationData = await $http.get(apiBase, config);

        // if we can find data, we must add tot eh scanStationFieldsOrder array
        if (scanStationData.data != undefined && scanStationData.data.scanStationFieldsOrder != undefined) {
            scanStationFieldsOrder = scanStationData.data.scanStationFieldsOrder;
        }

        return scanStationFieldsOrder;

    };


    /**
     * This will be getting the Station Data for the Dropdown.
     *
     * @param localStationID
     * @param stationAndField
     * @param dropdownFromStationOnlyDataAfterDate
     * @param origin
     * @param localFieldMatchingFieldPairs
     * @param reverse
     * @param dropDownFromStationExcludeMatchingDataFromAnotherFieldData
     * @param localFieldExclusionMatchingFieldPairs
     */
    Factory.getStationDataForDropDown = (localStationID, stationAndField, dropdownFromStationOnlyDataAfterDate, origin,
        localFieldMatchingFieldPairs, reverse, dropDownFromStationExcludeMatchingDataFromAnotherFieldData,
        localFieldExclusionMatchingFieldPairs, dropdownFromStationOrder, dropdownCustomDisplayFormat) => {

        let apiBase = Factory.evervaultEnabledApiUrl + "get-station-data-for-dropdown";

        let config = {
            params: {
                localStationID: localStationID,
                stationAndField: stationAndField,
                dropdownFromStationOnlyDataAfterDate: dropdownFromStationOnlyDataAfterDate,
                origin: origin,
                localFieldMatchingFieldPairs: localFieldMatchingFieldPairs,
                reverse: reverse,
                dropDownFromStationExcludeMatchingDataFromAnotherFieldData: dropDownFromStationExcludeMatchingDataFromAnotherFieldData,
                localFieldExclusionMatchingFieldPairs: localFieldExclusionMatchingFieldPairs,
                dropdownFromStationOrder: dropdownFromStationOrder,
                dropdownCustomDisplayFormat: dropdownCustomDisplayFormat,
            },
        };

        return $http.get(apiBase, config);
    };

    /**
     * This will remove the image Preview.
     * @param dataToAdd
     */
    Factory.removeImagePreview = (dataToAdd) => {

        angular.forEach(dataToAdd, function(dataToAddValue, dataToAddIndex: any) {
            if (dataToAddIndex.includes("_blocworx_imagePreview")) {
                delete dataToAdd[dataToAddIndex];
            }
        });

        return dataToAdd;
    };

    /**
     * This will add data to a ScanStation.
     */
    Factory.AddData = async (dataToAdd, scanStationID, testInstance, jobID, filesToAdd, submittedStatus, metaData) => {

        let fd = new FormData();

        let dataToAddCopy = { ...dataToAdd };

        dataToAddCopy = Factory.removeImagePreview(dataToAddCopy);

        angular.forEach(filesToAdd, function(file, index) {
            fd.append("uploaded-file-" + index, file);
        });

        fd.append("scanStationID", scanStationID);
        fd.append("metaData", JSON.stringify(metaData));
        fd.append("testInstance", testInstance);
        fd.append("jobID", jobID);
        fd.append("dataToAdd", JSON.stringify(dataToAddCopy));
        fd.append("submittedStatus", submittedStatus);

        let apiBase = Factory.evervaultEnabledApiUrl + "add-data";

        if (apiBase.includes("relay.evervault.com")) {

            let everVaultFieldSlugs = Factory.evervaultFieldSlugs.split(",");

            for (let i = 0; i < everVaultFieldSlugs.length; i++) {
                if (dataToAddCopy[everVaultFieldSlugs[i]] != null) {
                    fd.append("evervault_" + everVaultFieldSlugs[i], dataToAddCopy[everVaultFieldSlugs[i]]);
                }
                delete dataToAddCopy[everVaultFieldSlugs[i]];
            }
        }


        let data = await $http.post(apiBase, fd, {
            transformRequest: angular.identity,
            headers: { "Content-Type": undefined },
        });

        return data;
    };

    /**
     * This will be getting data for scanStation.
     */
    Factory.getData = (scanStationID, testInstance, includeCountsAndChecksTime, jobID, origin,
                       resultLimit, currentPage, reverse, fromDate, toDate, calendarPrimaryFieldFormat, sortByFieldId = null) => {

        let apiBase = Factory.evervaultEnabledApiUrl + "get-data";

        let config = {
            params: {
                scanStationID: scanStationID,
                includeCountsAndChecksTime: includeCountsAndChecksTime,
                jobID: jobID,
                testInstance: testInstance,
                origin: origin,
                resultLimit: resultLimit,
                currentPage: currentPage,
                reverse: reverse,
                fromDate: fromDate,
                toDate: toDate,
                calendarPrimaryFieldFormat: calendarPrimaryFieldFormat,
                sortByFieldId: sortByFieldId,
            },
        };
        return $http.get(apiBase, config);
    };

    /**
     * This will be getting the Calendar Data.
     */
    Factory.getCalendarData = (scanStationID, jobID, origin, calendarFromDate, calendarToDate, calendarPrimaryFieldFormat) => {

        let apiBase = Factory.apiUrl + "get-calendar-data";
        let config = {
            params: {
                scanStationID: scanStationID,
                jobID: jobID,
                origin: origin,
                calendarFromDate: calendarFromDate,
                calendarToDate: calendarToDate,
                calendarPrimaryFieldFormat: calendarPrimaryFieldFormat,
            },
        };

        return $http.get(apiBase, config);
    };

    /**
     * This will be getting a Single Data Entry for the Scan Station Edit.
     */
    Factory.getSingleDataEntryForStationEdit = (stationDataID, publicFormKey, publicFormValue) => {

        let apiBase = Factory.apiUrl + "get-single-data-for-station-edit";

        let config = {
            params: {
                stationDataID: stationDataID,
                publicFormKey: publicFormKey,
                publicFormValue: publicFormValue,
            },
        };
        return $http.get(apiBase, config);
    };

    /**
     * This will load More data action.
     */
    Factory.loadMoreData = (scanStationID, quantity) => {

        let apiBase = Factory.apiUrl + "load-more-data";

        let config = {
            params: {
                scanStationID: scanStationID,
                quantity: quantity,
                origin: "scan-station",
            },
        };
        return $http.get(apiBase, config);
    };

    /**
     * This will load all rules.
     */
    Factory.getRules = (field_id, data, stationDataID, allFieldsData) => {

        let apiBase = Factory.evervaultEnabledApiUrl + "get-rules";
        let config = {
            field_id: field_id,
            data: data,
            stationDataID: stationDataID,
            allFieldsData: allFieldsData,
        };

        return $http.post(apiBase, config);
    };

    /**
     * This will load All Actions.
     */
    Factory.loadAllActions = (stationId, allFieldsData, data = null) => {

        let apiBase = Factory.apiUrl + "load-all-actions";
        let config = {
            stationId: stationId,
            allFieldsData: allFieldsData,
            data: data,
        };

        return $http.post(apiBase, config);
    };

    /**
     * This will be getting Multiple Rules.
     */
    Factory.getMultipleRules = (ruleDataToCheck, stationDataID, allFieldsData, recurringData, isInEditMode) => {

        let apiBase = Factory.apiUrl + "get-multiple-rules";
        let data = {
            ruleDataToCheck: ruleDataToCheck,
            stationDataID: stationDataID,
            allFieldsData: allFieldsData,
            recurringData: recurringData,
            isInEditMode: isInEditMode,
        };
        return $http.post(apiBase, data);
    };

    /**
     * This will be getting all external Jobs by providing a keyword.
     *
     * @param keyword
     */
    Factory.getExternalJobsByKeyWord = (keyword) => {

        let apiBase = Factory.apiUrl + "get-external-jobs-by-keyword";
        let config = {
            params: {
                keyword: keyword,
            },
        };
        return $http.get(apiBase, config);
    };

    /**
     * This will be getting the scan station jobs.
     *
     * @param jobID
     * @param sectionID
     */
    Factory.getJobScanStations = (jobID, sectionID) => {
        let apiBase = Factory.apiUrl + "get-scan-stations";
        let config = {
            params: {
                jobID: jobID,
                sectionID: sectionID,
            },
        };
        return $http.get(apiBase, config);
    };

    /**
     * Undo action.
     *
     * @param scanStationID
     */
    Factory.undo = (scanStationID) => {
        let apiBase = Factory.apiUrl + "undo";

        let config = {
            handleError: true,
            params: {
                scanStationID: scanStationID,
            },
        };
        return $http.get(apiBase, config);
    };

    /**
     * This will get the field parameters.
     *
     * @param fieldId
     */
    Factory.getFieldParameters = (fieldId) => {

        let apiBase = Factory.apiUrl + "get-field-parameters";
        let config = {
            handleError: true,
            params: {
                fieldId: fieldId,
            },
        };
        return $http.get(apiBase, config);
    };

    /**
     * This will be adding Station user.
     */
    Factory.addStationUser = (scanStationID, jobID, selectedUserID) => {
        let apiBase = Factory.apiUrl + "add-station-user";
        let config = {
            params: {
                scanStationID: scanStationID,
                jobID: jobID,
                selectedUserID: selectedUserID,
            },
        };

        return $http.get(apiBase, config);
    };

    /**
     * This will get the station users.
     */
    Factory.getStationUsers = async (scanStationId) => {

        let scanStationUsers = [];
        let apiBase = Factory.apiUrl + "get-station-users";
        let config = {
            params: {
                scanStationId: scanStationId,
            },
        };

        // loading station_user
        let data = await $http.get(apiBase, config);
        if (data?.data?.data) {
            Factory.scanStationUsers = data?.data?.data;
        }

        return Factory.scanStationUsers;
    };

    /**
     * This will delete user for a ScanStation.
     */
    Factory.deleteUserFromStation = (stationUserID) => {

        let apiBase = Factory.apiUrl + "delete-user-from-station";

        let config = {
            params: {
                stationUserID: stationUserID,
            },
        };

        return $http.delete(apiBase, config);
    };

    /**
     * This will update Station Settings.
     *
     * @param stationID
     * @param stationSetting
     * @param value
     */
    Factory.updateStationSetting = (stationID, stationSetting, value) => {

        let apiBase = Factory.apiUrl + "update-station-setting";

        let data = {

            stationID: stationID,
            stationSetting: stationSetting,
            value: value,
        };
        return $http.post(apiBase, data);
    };

    /**
     * This will import Data From Excell.
     *
     * @param scanStationID
     * @param jobID
     * @param importDuplicateOptions
     * @param excelDataFile
     */
    Factory.importDataFromExcel = (scanStationID, jobID, importDuplicateOptions, excelDataFile) => {

        let fd = new FormData();
        fd.append("scanStationID", scanStationID);
        fd.append("jobID", jobID);
        fd.append("excel-data", excelDataFile);
        fd.append("importDuplicateOptions", JSON.stringify(importDuplicateOptions));
        let apiBase = Factory.apiUrl + "import-data-from-excel";


        return $http.post(apiBase, fd, {
            transformRequest: angular.identity,
            headers: { "Content-Type": undefined },
        });
    };

    /**
     * This will get House Keeping for Audit Task for a User.
     * @param jobID
     * @param userID
     */
    Factory.getAntiStaticSignedForUser = (jobID, userID) => {
        let apiBase = Factory.apiUrl + "get-anti-static-signed-for-user";

        let config = {
            params: {
                jobID: jobID,
                userID: userID,
            },
        };

        return $http.get(apiBase, config);
    };

    /**
     * This will get SO Signed for a User.
     * @param jobID
     * @param stationID
     * @param userID
     */
    Factory.getSOPSignedForUser = (jobID, stationID, userID) => {

        let apiBase = Factory.apiUrl + "get-sop-signed-for-user";
        let config = {
            params: {
                jobID: jobID,
                stationID: stationID,
                userID: userID,
            },
        };

        return $http.get(apiBase, config);
    };

    /**
     * This will get the sections.
     *
     * @param jobID
     */
    Factory.getSections = (jobID) => {

        let apiBase = Factory.apiUrl + "get-sections";

        let config = {
            params: {
                jobID: jobID,
            },
        };

        return $http.get(apiBase, config);
    };

    /**
     * This will Sign an Item.
     *
     * @param jobID
     * @param userID
     * @param password
     * @param itemSigned
     */
    Factory.signItem = (jobID, userID, password, itemSigned) => {

        let apiBase = Factory.apiUrl + "sign-item";

        let data = {
            jobID: jobID,
            userID: userID,
            password: password,
            itemSigned: itemSigned,
        };
        return $http.post(apiBase, data);
    };

    /**
     * This will load an Anti Static Entry.
     *
     * @param userID
     * @param signInPassword
     */
    Factory.logAntiStaticEntry = (userID, signInPassword) => {

        let apiBase = Factory.apiUrl + "log-in-static-entry";
        let data = {
            userID: userID,
            signInPassword: signInPassword,
        };
        return $http.post(apiBase, data);
    };

    /**
     * This will update Field Parameter.
     *
     * @param fieldID
     * @param toUpdate
     * @param parameters
     */
    Factory.updateFieldParameter = (fieldID, toUpdate, parameters) => {

        let apiBase = Factory.apiUrl + "update-field-parameter";
        let data = {
            fieldID: fieldID,
            toUpdate: toUpdate,
            parameters: parameters,
        };
        return $http.post(apiBase, data);
    };

    /**
     * This will update data from Station.
     *
     * @param rowID
     * @param key
     * @param value
     */
    Factory.updateDataFromStation = (rowID, key, value) => {

        let apiBase = Factory.apiUrl + "update-data-from-station";
        let data = {
            rowID: rowID,
            key: key,
            value: value,
        };

        return $http.post(apiBase, data);
    };

    /**
     * This will create a new Revision of a Scan Station.
     *
     * @param stationID
     */
    Factory.createNewRevisionOfStation = (stationID) => {

        let apiBase = Factory.apiUrl + "create-new-revision-of-station";

        let config = {
            params: {
                currentStationId: stationID,
            },
        };
        return $http.get(apiBase, config);
    };

    /**
     * This is the function that will trigger the duplication of the process
     * of duplicate a bloc, so this will try to duplicate the bloc phrase
     * so needs to have scan station id and the job id, so we can know what was
     * the job that started the action, so we can differ from who started
     * the process from other ones that also copied the same scan station id.
     *
     * @param scanStationId
     * @param jobId
     * @param userId
     */
    Factory.duplicateStationFromWithinStation = (scanStationId, jobId, userId) => {

        let apiBase = Factory.apiUrl + "duplicate-station-from-within-station";
        let config = {
            params: {
                scanStationId: scanStationId,
                jobId: jobId,
                userId: userId,
            },
        };
        return $http.get(apiBase, config);
    };

    /**
     * This will update field Details.
     *
     * @param stationID
     * @param fieldIDForUpdatingRules
     * @param fieldNametoUpdateTo
     * @param fieldTypeToUpdateTo
     * @param fieldDataToUpdateTo
     * @param initialFieldParams
     */
    Factory.updateFieldDetails = (stationID, fieldIDForUpdatingRules, fieldNametoUpdateTo, fieldTypeToUpdateTo,
                                  fieldDataToUpdateTo, initialFieldParams) => {

        let apiBase = Factory.apiUrl + "update-field-details";
        let data = {
            stationID: stationID,
            fieldIDForUpdatingRules: fieldIDForUpdatingRules,
            fieldNametoUpdateTo: fieldNametoUpdateTo,
            fieldTypeToUpdateTo: fieldTypeToUpdateTo,
            fieldDataToUpdateTo: fieldDataToUpdateTo,
            initialFieldParams: initialFieldParams,
        };
        return $http.post(apiBase, data);
    };

    Factory.getStationAndJobAndStationBySpecialKey = (specialKey) => {

        let apiBase = Factory.apiUrl + "get-station-and-job-by-special-key";
        let config = {
            params: {
                specialKey: specialKey,
            },
        };
        return $http.get(apiBase, config);
    };

    /**
     * This will get an Independent Station Job ID and Scan Station ID.
     */
    Factory.getIndependantStationJobIDandStationID = (independantStationSlug) => {

        let apiBase = Factory.apiUrl + "get-independant-station-job-id-station-id";
        let config = {
            params: {
                independantStationSlug: independantStationSlug,
            },
        };
        return $http.get(apiBase, config);
    };

    /**
     * This will be getting a static job Slug.
     *
     * @param jobID
     */
    Factory.getStaticJobSlug = (jobID) => {

        let apiBase = Factory.apiUrl + "get-static-job-slug";
        let config = {
            params: {
                jobID: jobID,
            },
        };
        return $http.get(apiBase, config);
    };

    /**
     * This will be adding a selected role for a Field ID.
     *
     * @param selectedRoleSlug
     * @param fieldID
     */
    Factory.addSelectedRoleForFieldID = (selectedRoleSlug, fieldID) => {

        let apiBase = Factory.apiUrl + "add-selected-role-for-field-id";
        let data = {
            selectedRoleSlug: selectedRoleSlug,
            fieldID: fieldID,
        };
        return $http.post(apiBase, data);
    };

    /**
     * This will be getting a selected Rile for a Field ID
     * @param fieldID
     */
    Factory.getSelectedRolesForFieldID = (fieldID) => {

        let apiBase = Factory.apiUrl + "get-selected-roles-for-field-id";
        let config = {
            params: {
                fieldID: fieldID,
            },
        };

        return $http.get(apiBase, config);
    };

    /**
     * This will remove the selected role for a Field ID passed.
     *
     * @param id
     */
    Factory.removeSelectedRoleForFieldID = (id) => {

        let apiBase = Factory.apiUrl + "remove-selected-role-for-field-id";
        let config = {
            params: {
                id: id,
            },
        };
        return $http.delete(apiBase, config);
    };

    /**
     * This will search Users by a key.
     *
     * @param userSearchKey
     */
    Factory.searchUsersByKey = (userSearchKey) => {
        let apiBase = Factory.apiUrl + "search-users-by-key";
        let config = {
            params: {
                userSearchKey: userSearchKey,
            },
        };
        return $http.get(apiBase, config);
    };

    /**
     * This will add Documents to Sign.
     *
     * @param newDocumentSignTrigger
     */
    Factory.addDocumentSignTrigger = (newDocumentSignTrigger) => {
        let apiBase = Factory.apiUrl + "add-document-sign-trigger";
        let data = {
            newDocumentSignTrigger: newDocumentSignTrigger,
        };
        return $http.post(apiBase, data);
    };

    /**
     * This will delete Documents Sign.
     *
     * @param id
     */
    Factory.deleteDocumentSignTrigger = (id) => {
        let apiBase = Factory.apiUrl + "delete-document-sign-trigger";
        let config = {
            params: {
                id: id,
            },
        };
        return $http.delete(apiBase, config);
    };

    /**
     * This will get Documents Sign Data.
     *
     * @param id
     */
    Factory.getDocumentSignTriggerData = (id) => {
        let apiBase = Factory.apiUrl + "get-document-sign-trigger-data";
        let config = {
            params: {
                id: id,
            },
        };
        return $http.get(apiBase, config);
    };

    /**
     * This will get Document Sign Triggers.
     *
     * @param stationID
     */
    Factory.getDocumentSignTriggers = (stationID) => {
        let apiBase = Factory.apiUrl + "get-document-sign-triggers";
        let config = {
            params: {
                stationID: stationID,
            },
        };
        return $http.get(apiBase, config);
    };


    /**
     * This will add a Colour Scheme.
     *
     * @param colourScheme
     */
    Factory.addColourScheme = (colourScheme) => {

        let apiBase = Factory.apiUrl + "add-colour-scheme";
        let body = {
            colourScheme: colourScheme,
        };
        return $http.post(apiBase, body);
    };

    /**
     * This will delete the Colour Scheme.
     *
     * @param name
     * @param id
     */
    Factory.deleteColourScheme = (name, id) => {
        let apiBase = Factory.apiUrl + "delete-colour-scheme";
        let body = {
            name: name,
            id: id,
        };
        return $http.post(apiBase, body);
    };

    /**
     * This will get the Colour Scheme.
     *
     * @param id
     */
    Factory.getColourSchemes = (id) => {

        let apiBase = Factory.apiUrl + "get-colour-schemes";
        let body = {
            id: id,
        };
        return $http.post(apiBase, body);
    };

    /**
     * This will be getting auto generated field Data.
     *
     * @param fieldData
     * @param fieldType
     * @param id
     * @param fieldSlug
     */
    Factory.getAutoGeneratedFieldData = (fieldId, scanStationId, dataToAdd) => {
        let apiBase = Factory.apiUrl + "auto-generate-data-field";
        let body = {
            fieldId: fieldId,
            scanStationID: scanStationId,
            dataToAdd: dataToAdd,
        };
        return $http.post(apiBase, body);
    };

    /**
     * This will set field visibility parameter.
     *
     * @param fieldID
     * @param visibilityParameter
     */
    Factory.setFieldVisibilityParameter = (scanStationId, fieldID, visibilityParameter) => {

        let apiBase = Factory.apiUrl + "set-field-visibility-option";
        let body = {
            fieldID: fieldID,
            scan_station_id: scanStationId,
            visibilityParameter: visibilityParameter,
        };
        return $http.post(apiBase, body);
    };

    /**
     * This will be getting the field Visibility Option.
     *
     * @param fieldID
     */
    Factory.getFieldVisibilityOptions = (fieldID) => {
        let apiBase = Factory.apiUrl + "get-field-visibility-option";
        let body = {
            fieldID: fieldID,
        };
        return $http.post(apiBase, body);
    };

    /**
     * This will delete field Visibility Option.
     *
     * @param fhID
     */
    Factory.deleteFieldVisibilityOptions = (fhID) => {

        let apiBase = Factory.apiUrl + "delete-field-visibility-option";
        let body = {
            fhID: fhID,
        };
        return $http.post(apiBase, body);
    };

    /**
     * This will set Form Visibility Parameter.
     *
     * @param scanStationID
     * @param visibilityParameter
     */
    Factory.setFormVisibilityParameter = (scanStationID, visibilityParameter) => {
        let apiBase = Factory.apiUrl + "set-form-visibility-option";
        let body = {
            scanStationID: scanStationID,
            visibilityParameter: visibilityParameter,
        };
        return $http.post(apiBase, body);
    };

    /**
     * This will be getting a form Visibility Parameter.
     *
     * @param scanStationID
     */
    Factory.getFormVisibilityParameter = (scanStationID) => {
        let apiBase = Factory.apiUrl + "get-form-visibility-option";
        let body = {
            scanStationID: scanStationID,
        };
        return $http.post(apiBase, body);
    };

    /**
     * This will be printing to a PDF.
     *
     * @param scanStationID
     * @param dataToAdd
     * @param chosenTemplateFile
     * @param pdfOrWord
     */
    Factory.printToPDF = (scanStationID, dataToAdd, chosenTemplateFile, pdfOrWord) => {
        let apiBase = Factory.apiUrl + "print-form";
        let config = {
            responseType: "blob",
        };

        let body = {
            scanStationID: scanStationID,
            dataToAdd: dataToAdd,
            chosenTemplateFile: chosenTemplateFile,
            pdfOrWord: pdfOrWord,
        };

        return $http.post(apiBase, body, config);
    };

    /**
     * This will be getting Scan Station Fields.
     *
     * @param scanStationID
     */
    Factory.getScanStationFields = (scanStationID) => {

        let apiBase = Factory.apiUrl + "get-scan-station-fields";
        let body = {
            scanStationID: scanStationID,
        };
        return $http.post(apiBase, body);
    };

    /**
     * This will be getting Scan Station Details.
     *
     * @param scanStationID
     */
    Factory.getScanStationDetails = (scanStationID) => {
        let apiBase = Factory.apiUrl + "get-scan-station-details";
        let body = {
            scanStationID: scanStationID,
        };
        return $http.post(apiBase, body);
    };

    /**
     * This is setting a ScanStation field Parameter.
     *
     * @param fieldID
     * @param fieldParameter
     * @param paramValue
     * @param parameterInstruction
     */
    Factory.setScanStationFieldParameter = (fieldID, fieldParameter, paramValue, parameterInstruction) => {

        let apiBase = Factory.apiUrl + "set-scan-station-field-parameters";
        let body = {
            fieldID: fieldID,
            fieldParameter: fieldParameter,
            paramValue: paramValue,
            parameterInstruction: parameterInstruction,
        };
        return $http.post(apiBase, body);
    };

    /**
     * This will be duplication a scan station field.
     *
     * @param field
     */
    Factory.duplicateStationField = (field) => {

        let apiBase = Factory.apiUrl + "duplicate-field";
        let body = {
            field: field,
        };
        return $http.post(apiBase, body);
    };

    /**
     * This will load data of a field.
     *
     * @param fieldId
     */
    Factory.loadField = async (fieldId) => {

        let fieldData = undefined;
        let apiBase = Factory.apiUrl + "load-field";
        let body = {
            fieldId: fieldId,
        };
        let responseData = await $http.post(apiBase, body);
        if (responseData.data != null && responseData.data.success != undefined) {
            fieldData = responseData.data.field;
        }

        return fieldData;
    };

    /**
     * This will be setting a Scan Station Parameter.
     *
     * @param stationID
     * @param stationParam
     * @param paramValue
     */
    Factory.setScanStationParameter = (stationID, stationParam, paramValue) => {
        let apiBase = Factory.apiUrl + "set-scan-station-parameters";
        let body = {
            stationID: stationID,
            stationParam: stationParam,
            paramValue: paramValue,
        };
        return $http.post(apiBase, body);
    };

    /**
     * This will be removing a Scan Station Parameter.
     *
     * @param stationID
     * @param stationParam
     */
    Factory.removeScanStationParameter = (stationID, stationParam) => {
        let apiBase = Factory.apiUrl + "remove-scan-station-parameters";
        let body = {
            params: {
                stationID: stationID,
                stationParam: stationParam,
            },
        };
        return $http.delete(apiBase, body);
    };

    /**
     * This method will trigger the update of the archived data
     * of a scan station, by using its id.
     *
     * @param stationID
     */
    Factory.unArchiveData = (stationID) => {
        let apiBase = Factory.apiUrl + "un-archive-data";
        let body = {
            stationID: stationID,
        };
        return $http.post(apiBase, body);
    };

    /**
     * This will auto generate Trainee Data.
     *
     * @param jobID
     * @param stationID
     * @param productionName
     * @param productionWeekNumber
     * @param selectedSupervisor
     * @param selectedTrainee
     * @param noOfWeeks
     * @param selectedSupervisorUsername
     * @param selectedTraineeUsername
     */
    Factory.autoGenerateTraineeData = (jobID, stationID, productionName, productionWeekNumber, selectedSupervisor, selectedTrainee,
                                       noOfWeeks, selectedSupervisorUsername, selectedTraineeUsername) => {

        let apiBase = Factory.apiUrl + "troy-generate-trainee-data";
        let body = {
            jobID: jobID,
            stationID: stationID,
            productionName: productionName,
            productionWeekNumber: productionWeekNumber,
            selectedSupervisor: selectedSupervisor,
            selectedTrainee: selectedTrainee,
            noOfWeeks: noOfWeeks,
            selectedSupervisorUsername: selectedSupervisorUsername,
            selectedTraineeUsername: selectedTraineeUsername,
        };
        return $http.post(apiBase, body);
    };

    /**
     * This will get data to Form Check Linked Station (Adrian can you explain this bettter?)
     * @param dataToCheck
     * @param fieldToWatch
     * @param linkedStation
     * @param linkedJob
     */
    Factory.dataToFormCheckLinkedStation = (dataToCheck, fieldToWatch, linkedStation, linkedJob) => {

        let apiBase = Factory.apiUrl + "data-to-form-check-linked-station";
        let data = {
            dataToCheck: dataToCheck,
            fieldToWatch: fieldToWatch,
            linkedStation: linkedStation,
            linkedJob: linkedJob,
        };
        return $http.post(apiBase, data);
    };

    /**
     * This will build Bloc list with latest Data.
     *
     * @param fieldId
     * @param stationIdsToCheck
     * @param filteringOptions
     * @param allFieldsData
     */
    Factory.buildBlocListLatestData = (fieldId, stationIdsToCheck, filteringOptions, allFieldsData) => {
        let apiBase = Factory.apiUrl + "build-bloc-list-latest-data";
        let data = {
            fieldId: fieldId,
            stationIdsToCheck: stationIdsToCheck,
            filteringOptions: filteringOptions,
            allFieldsData: allFieldsData,
        };
        return $http.post(apiBase, data);
    };


    /**
     * This will be getting base 64 image.
     *
     * @param jobID
     * @param stationID
     * @param fileName
     */
    Factory.getBase64Image = (jobID, stationID, fileName) => {

        let apiBase = Factory.apiUrl + "get-base-64-image";
        let config = {
            params: {
                jobID: jobID,
                stationID: stationID,
                fileName: fileName,
            },
        };
        return $http.get(apiBase, config);
    };

    /**
     * This will be generating File for Bartender.
     *
     * @param folderToDropInto
     * @param fileNameToCreate
     * @param fieldValuesToSend
     */
    Factory.generateFileForBartender = (folderToDropInto, fileNameToCreate, fieldValuesToSend) => {

        let apiBase = Factory.apiUrl + "generate-file-for-bartender";
        let data = {
            folderToDropInto: folderToDropInto,
            fileNameToCreate: fileNameToCreate,
            fieldValuesToSend: fieldValuesToSend,
        };
        return $http.post(apiBase, data);
    };

    /**
     * This will be loading an Icon by the Scan Station ID.
     *
     * @param scanStationId
     */
    Factory.loadIcon = async (scanStationId) => {

        let apiBase = Factory.apiUrl + "load-scan-station-icon";
        let config = {
            params: {
                scanStationId: scanStationId,
            },
        };

        let icon = await $http.get(apiBase, config);

        return icon.data.icon;

    };

    /**
     * This will upload Multiple files.
     *
     * @param jobID
     * @param stationID
     * @param files
     */
    Factory.uploadMultipleFiles = (jobID, stationID, files, fieldSlug) => {

        let fd = new FormData();
        fd.append("jobID", jobID);
        fd.append("stationID", stationID);

        let i = 0;
        angular.forEach(files, function(value) {
            fd.append("file_" + fieldSlug + "_" + i, value);
            i++;
        });

        let apiBase = Factory.evervaultEnabledApiUrl + "upload-multiple-files";
        return $http.post(apiBase, fd, {
            transformRequest: angular.identity,
            headers: { "Content-Type": undefined },
        });
    };


    Factory.loadMultiFilesForDisplayInForm = (fileNames) => {

        let config = {
            params: {
                fileNames: fileNames,
            },
        };

        let apiBase = Factory.apiUrl + "load-multi-files-for-display-in-form";

        return $http.get(apiBase, config, {
            transformRequest: angular.identity,
            headers: { "Content-Type": undefined },

        });
    };
    /**
     * This will get the current Scan Station Auto generate Number avaiable.
     *
     * @param scanStationId
     */
    Factory.getCurrentScanStationAutoGeneratedNumberAvailable = async (scanStationId) => {

        let apiBase = Factory.apiUrl + "get-current-scan-station-auto-generated-number-available";
        let config = {
            params: {
                scanStationId: scanStationId,
            },
        };

        let number = await $http.get(apiBase, config);

        return number.data;

    };

    /**
     * Tis will se the current Scan Station for the Auto generate number
     * available.
     *
     * @param scanStationId
     * @param autoGenerateNumber
     * @param processed
     * @param processedBy
     */
    Factory.setCurrentScanStationAutoGeneratedNumberAvailable = async (scanStationId, autoGenerateNumber, processed = 0, processedBy = 0) => {

        let apiBase = Factory.apiUrl + "set-current-scan-station-auto-generated-number-available";
        let data = {
            scanStationId: scanStationId,
            autoGenerateNumber: autoGenerateNumber,
            processed: processed,
            processedBy: processedBy,
        };
        return $http.post(apiBase, data);

    };

    /**
     * This will filter the scanstation data by click on the calendar.
     *
     * @param scanStationID
     * @param dataFilteringData
     * @param fieldIdOrFieldSlug
     */
    Factory.getScanStation = async (scanStationID, cartolyticsCustomerID) => {

        let scanStation = false;
        let apiBase = Factory.apiUrl + "get-scan-station";
        let config = {
            params: {
                scanStationID: scanStationID,
                cartolyticsCustomerID: cartolyticsCustomerID,
            },
        };

        let returnedData = await $http.get(apiBase, config);
        if (returnedData !== undefined) {
            scanStation = returnedData.data.scanStation;
        }

        return scanStation;

    };

    /**
     * The request to trigger actions and save the data for a results box editing
     * @param resultsBoxFieldData
     * @param saveData
     * @param applyRulesActionsForEditedRecord
     */
    Factory.triggerFieldActionsForSingleRecordInResultsBox = (resultsBoxFieldData, saveData, field) => {

        let data = {
            resultsBoxFieldData: resultsBoxFieldData,
            saveData: saveData,
            resultsBoxEditorApplyBlocInitialisation: field.resultsBoxEditorApplyBlocInitialisation,
            resultsBoxApplyFieldActions: field.resultsBoxApplyFieldActions,
            resultsBoxPreSubmitFeatures: field.resultsBoxPreSubmitFeatures,
            triggerSourcefieldId: field.id,
        };

        let apiBase = Factory.apiUrl + "trigger-field-actions-for-single-record-in-results-box";
        return $http.post(apiBase, data);
    };


    /**
     * This will update a scan Station Object Order.
     */
    Factory.runArchiveRecords = (scanStationObject) => {
        let apiBase = Factory.apiUrl + "run-archive-records";
        return $http.post(apiBase, {});
    };

    /**
     * This strips the value of all special characters
     * @param value
     */
    Factory.stripSpecialCharacters = async (string) => {

        let apiBase = Factory.apiUrl + "strip-special-characters-from-string";
        let data = {
            string: string,
        };
        return $http.post(apiBase, data);

    };

    /**
     * This will be getting the scanStation Rules.
     */
    Factory.getSingleRecordByRecordId = async (recordId, restrictByFieldSlugs = []) => {

        let apiBase = Factory.evervaultEnabledApiUrl + "get-single-record-by-record-id";

        let config = {
            params: {
                recordId: recordId,
                restrictByFieldSlugs: restrictByFieldSlugs,
            },
        };
        return $http.get(apiBase, config);
    };

    /**
     * This duplicates a record by scan station data ID
     * @param value
     */
    Factory.duplicateRecord = async (recordId) => {

        let apiBase = Factory.apiUrl + "duplicate-record";
        let data = {
            recordId: recordId,
        };
        return $http.post(apiBase, data);

    };
    /**
     * This will perform a light update on a record, its just a direct update from dataToAdd
     */

    Factory.performLightUpdate = (recordId, dataToAdd, fieldId) => {

        let apiBase = Factory.apiUrl + "perform-light-update";

        let data = {
            recordId: recordId,
            dataToAdd: dataToAdd,
            fieldId: fieldId,
        };

        return $http.post(apiBase, data);
    };


    // this will make sure that will be the constructor class like a controller one
    Factory.$onInit();

    return Factory;

}

function ScanStationServiceConfig($compileProvider) {
    $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|tel|file|blob):/);
}
